import styled from "styled-components";
import { FlexRow } from "../../../../../Common/Styles";

export const EmptyContainer = styled.div`
  padding: ${({ theme }) => theme.spacing["spacing-6"].value}rem
    ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-m"]};
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  background-color: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
`;

export const BorderContainer = styled.div`
  padding: ${({ theme }) => theme.spacing["spacing-1"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-l"].value}rem;
  border: ${({ theme }) => theme.border_width["border-width-thin"].value}rem
    solid ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
`;
export const Container = styled.div`
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-m"].value}rem;
  background-color: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary-emphasize-hover"].value};
`;
export const Wrapper = styled(Container)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  background: linear-gradient(
    125deg,
    ${({ theme }) => theme.Color.icon.brand.subtlest["default-hover"].value}
      14.9%,
    ${({ theme }) => theme.Color.border.brand.subtle.default.value} 55.13%
  );
`;
export const InfoContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-s"]};
  padding: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-none"].value}rem
    ${({ theme }) => theme.radius["radius-xs"].value}rem
    ${({ theme }) => theme.radius["radius-xs"].value}rem
    ${({ theme }) => theme.radius["radius-xs"].value}rem;
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
`;

export const NotPostedContainer = styled(FlexRow)`
  align-items: center;
`;

export const BackgroundContainer = styled.div`
  border-radius: 4px;
  background: linear-gradient(
    93deg,
    ${({ theme }) => theme.Color.background.brand.default.value} 2.1%,
    #b175fd 112.77%
  );
  button {
    border: none;
    label {
      color: ${({ theme }) => theme.Color.icon["icon-inverse"].value};
      font-weight: 600;
    }
  }
`;

export const SelectedCircleContainer = styled.div`
  position: absolute;
  top: -${({ theme }) => theme.spacing["spacing-6"].value}rem;
  left: ${({ theme }) => theme.spacing["spacing-none"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-1"].value}rem
    ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem
    ${({ theme }) => theme.radius["radius-xxs"].value}rem 0px 0px;
  border-bottom: 2px solid
    ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
  height: ${({ theme }) => theme.spacing["spacing-6"].value}rem;
`;

export const IconContainer = styled(FlexRow)`
  gap: 0px;
  & svg {
    margin-left: -6px;
    &:first-child {
      margin-left: 0px;
    }
  }
`;
